<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
      :updateHideFields="updateHideFields"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/user";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: ["sequence", "email", "name", "updated_info"],
    updateHideFields: ["email"],
    liveSearching: true,
    sortBy: "sequence",
  }),
};
</script>

<style>
</style>